import React, {useEffect} from 'react';
import {Typography} from '@customink/pigment-react';
import {ProductVariantsInner, SizesInner} from '@customink/stores-api-client';
import {useGetStoreProductQuery} from '../../api/storesApi';
import SizeBox from './SizeBox';

type Props = {
  currentSize: SizesInner;
  currentVariant: ProductVariantsInner;
  setCurrentSize: (size: SizesInner) => void;
  storeSlug: string;
  productId: number;
  isLayout?: boolean;
};

const StoreProductSizePicker: React.FC<Props> = ({
  currentSize,
  currentVariant,
  setCurrentSize,
  productId,
  storeSlug,
  isLayout
}: Props) => {
  const {data: product} = useGetStoreProductQuery({
    urlSlug: storeSlug,
    productId
  });
  const {sizes} = product || {};
  const isOneSize = sizes?.length === 1;
  const sizeOptions = sizes?.length > 1 ? sizes : [];
  const availableSizes = currentVariant?.sizes.map(size => size.value);
  const unclickableClass = `${isLayout ? ' sizeBoxes--layout' : ''}`;

  useEffect(() => {
    if (isOneSize && !currentSize) setCurrentSize(sizes[0]);
  }, [currentSize, isOneSize, sizes]);

  const labelText = currentSize?.label || '';
  const label = (
    <Typography
      className="storeProductSizePicker-sizeText"
      variant="subHeading">
      Size:{' '}
      <span className="storeProductSizePicker-labelSpan">{labelText}</span>
    </Typography>
  );
  return sizes ? (
    <div className="storeProductSizePicker">
      {!isLayout ? label : null}
      <div className={`storeProductSizePicker-sizeBoxes${unclickableClass}`}>
        {sizeOptions.map((size: SizesInner) => (
          <SizeBox
            key={size.value}
            size={size.value}
            selected={currentSize?.value === size.value}
            disabled={!availableSizes?.includes(size.value)}
            onSelect={() => {
              setCurrentSize(size);
            }}
          />
        ))}
      </div>
    </div>
  ) : null;
};

StoreProductSizePicker.defaultProps = {
  isLayout: false
};

export default StoreProductSizePicker;
